import { type CancellationStep } from "@/types/types";

export const cancelChurnFlow: CancellationStep[] = [
  {
    id: "welcome",
    next: "ask_cancellation_reason",
    choices: null,
    status: null,
    title:
      "Unused conversion time rolls over to the next month. If you cancel your subscription, you'll lose any saved up conversion time at the end of the billing period",
  },
  {
    id: "ask_cancellation_reason",
    next: null,
    choices: [
      {
        reason: "Dissatisfied with features",
        answer: null,
        next: "show_feedback_form",
      },
      { reason: "Found an alternative", answer: null, next: "apply_discount" },
      { reason: "Too expensive", answer: null, next: "apply_discount" },
      { reason: "Technical issues", answer: null, next: "connect_support" },
      {
        reason: "Not needed anymore",
        answer: null,
        next: "show_feedback_form",
      },
      { reason: "Other", answer: null, next: "show_feedback_form" },
    ],
    status: null,
    title: "Can you tell us why you are canceling your subscription?",
  },
  {
    id: "show_feedback_form",
    next: "confirm_cancellation",
    choices: null,
    status: null,
    title:
      "Help us improve Audimee by providing more details about why you are canceling.",
  },
  {
    id: "apply_discount",
    next: "user_stays",
    choices: null,
    status: null,
    title: "Before you leave, how about a special offer?",
  },
  {
    id: "connect_support",
    next: "user_stays",
    choices: null,
    status: null,
    title:
      "Feel free to contact us, our customer support team is ready to assist you.",
  },
  {
    id: "user_stays",
    next: null,
    choices: null,
    status: "retained",
    title:
      "We appreciate your decision to stay with us. Feel free to reach out to us if you need any help.",
  },
  {
    id: "confirm_cancellation",
    next: null,
    choices: null,
    status: "churned",
    title: "Are you sure you want to cancel your subscription?",
  },
  {
    id: "success_cancellation",
    next: null,
    choices: null,
    status: "success",
    title: "Subscription cancelled! Thank you for using our service.",
  },
] as const;
